module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.label) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328e9b0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabBox.vue
// module id = 594
// module chunks = 1